import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_open",
  "use": "icon-control_open-usage",
  "viewBox": "0 0 14.198 9.681",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.198 9.681\" id=\"icon-control_open\">\n  <defs>\n    \n  </defs>\n  <path id=\"icon-control_open_隐藏\" class=\"cls-1\" d=\"M135.069,252.462a7.6,7.6,0,0,0-7.1,4.84,7.626,7.626,0,0,0,14.2,0,7.6,7.6,0,0,0-7.1-4.84m0,8.067A3.227,3.227,0,1,1,138.3,257.3a3.2,3.2,0,0,1-3.227,3.227m0-5.163a1.936,1.936,0,1,0,1.936,1.936,1.9,1.9,0,0,0-1.936-1.936\" transform=\"translate(-127.97 -252.462)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol